import { render, staticRenderFns } from "./DailyReceivedReport.vue?vue&type=template&id=2a51437a&scoped=true&"
import script from "./DailyReceivedReport.vue?vue&type=script&lang=js&"
export * from "./DailyReceivedReport.vue?vue&type=script&lang=js&"
import style0 from "./DailyReceivedReport.vue?vue&type=style&index=0&id=2a51437a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51437a",
  null
  
)

export default component.exports